var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { attrs: { title: _vm.title } }, [
    _vm.loading
      ? _c("div", { staticClass: "mb-4 text-gray-500" }, [
          _vm._v("Loading Features Summary...")
        ])
      : _c(
          "div",
          [
            _c("p", { staticClass: "mb-4 text-gray-700" }, [
              _vm.featureCount
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.featureCount) +
                        " distinct features across " +
                        _vm._s(_vm.totalAccounts) +
                        " accounts. Most widely deployed: " +
                        _vm._s(_vm.topFeature.name) +
                        " (" +
                        _vm._s(_vm.topFeature.count) +
                        " accounts).\n      "
                    )
                  ])
                : _c("span", [_vm._v("No feature data available.")])
            ]),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "mb-4 text-sm text-gray-800 list-disc list-inside"
              },
              _vm._l(_vm.sortedSummaryFeatures, function(feat) {
                return _c("li", { key: feat.name }, [
                  _c("span", { staticClass: "font-bold" }, [
                    _vm._v(_vm._s(feat.name))
                  ]),
                  _vm._v(": " + _vm._s(feat.count) + " account"),
                  feat.count !== 1 ? _c("span", [_vm._v("s")]) : _vm._e()
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass:
                  "inline-flex items-center px-5 py-3 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200",
                attrs: { to: "/" + _vm.id + "/base2tools" }
              },
              [
                _vm._v("\n      View Detailed Features Report\n      "),
                _c(
                  "svg",
                  {
                    staticClass: "ml-2 h-4 w-4",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }
                  },
                  [_c("path", { attrs: { d: "M5 12h14M12 5l7 7-7 7" } })]
                )
              ]
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4af0fefa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af0fefa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/InfoCards/FeaturesCard.vue
// module id = null
// module chunks = 